/* eslint-disable no-unused-vars */
export enum Route {
  csrf = "/csrfs",
  rc3Script = "/reCaptcha/genScriptToken",
  domains = "/domains",
  languages = "/languages",
  uiText = "/uitext",
}

export enum UserRoute {
  login = "/user/login",
  profileUpdate = "/user/profile",
  getUserProfile = "/user/:userId/profile",
  getUserProfileImage = "/user/profile/image/:imageId",
  create = "/user",
  delete = "/user",
  get = "/user",
  createRole = "/user/3/roles",
  logout = "/user/logout",
  passwordChange = "/user/password/change",
  passwrodReset = "/user/password/reset",
  passwrodResetCallback = "/user/password/reset/callback",

  mfaEnable = "/user/mfa/enable",
  mfaConfirm = "/user/mfa/confirm",
  mfaVerify = "/user/mfa/verify",
  mfaDisable = "/user/mfa/disable",
  mfaFido2Register = "/user/mfa/fido2/register",
  mfaFido2Verify = "user/mfa/fido2/verify",
  mfaFido2Activate = "/user/mfa/fido2/activate",
  orgManage = "/org/manage",
  twoStepAuthentication = "/user/twoStepAuthentication",
  twoStepAuthenticationSetup = "/user/twoStepAuthenticationSetup",
  forgotPassword = "/user/forgotPassword",
  getCurrent = "/user/:userId",
  mfaWebauthnRegister = "/user/mfa/webauthn/registrationOptions",
  mfaWebauthnVerifyRegister = "/user/mfa/webauthn/registrationResponse",
  mfaWebauthnAuthenticate = "/user/mfa/webauthn/authenticationOptions",
  mfaWebauthnVerifyAuthentication = "/user/mfa/webauthn/authenticationResponse",

  getSalutations = "/user/salutations",
  mfaSelection = "/user/mfaSelection",
  postEmailUserVerify = "/user/email/verify",
  postEmailUserVerifyCallback = "/user/email/verify/callback",
  apiRecentSearches = "/user/search/history/:searchTypeId ",
  getRecentSearches = "/user/search/history",

  putActionMakeAsUnread = "/user/action/:actionId/mark/read/toggle",
  deleteNotification = "/user/action/:actionId/delete/toggle",
  deleteAllNotification = "/user/actions/all",
  markAllAsReadNotification = "/user/actions/mark/read/all",
}

export enum homeRoute {
  homePage = "/dashboard",
  welcomePage = "/welcome",
}

export enum recommendRoute {
  recommend = "/assess/roadmap",
}

export enum ProspectRoute {
  preview = "/prospect/preview",
  verify = "/prospect/verify",
  callback = "/prospect/callback",
  convertToUser = "/prospect/user",
  getQuests = "/prospect/questions",
  setQuests = "/prospect/questions",
  toUser = "/prospect/user",
  logout = "/prospect/logout",
  getProspectDomainsInvalid = "/prospect/domains/invalid",
}

export enum Todo {
  streamSave = "/todo/stream",
  deleteStream = "/todo/stream/:id",
  getRelatedStreams = "/todo/stream/related",
  getUserStreams = "/todo/stream/user/:id",

  activitySave = "/todo/activity",
  getRelatedActivities = "/todo/activity/related",
  getUserActivities = "/todo/activity/user/:id",
  deleteActivity = "/todo/activity/:id",
  getActivitiesOfUser = "/todo/activity/type/user",
  getChildActivities = "/todo/activity/children/:id",

  activityToUserSave = "/todo/activity-to-user",
  deleteActivityToUser = "/todo/activity-to-user/:id",

  streamToStreamSave = "/todo/stream-to-stream",
  deleteStreamToStream = "/todo/stream-to-stream/:id",

  activityToActivitySave = "/todo/activity-to-activity",
  deleteActivityToActivity = "/todo/activity-to-activity/:id",

  activityToStreamSave = "/todo/activity-to-stream",
  getActivitiesOfStream = "/todo/activities-of-stream",
  deleteActivityToStream = "/todo/activity-to-stream/:id",

  activityToTagSave = "/todo/activity-to-tag",
  deleteActivityToTag = "/todo/activity-to-tag/:id",
  getActivitiesOfTag = "/todo/activities-of-tag",

  tagSave = "/todo/tag",
  deleteTag = "/todo/tag/:id",

  streamToTagSave = "/todo/stream-to-tag",
  deleteStreamToTag = "/todo/stream-to-tag/:id",
  getStreamsOfTag = "/todo/streams-of-tag",

  activityToPartySave = "/todo/parties/activity-to-party",
  deleteActivityToParty = "/todo/parties/activity-to-party/:id",
  getActivityToPartyOfUser = "/todo/parties/activities/user/:id?",

  contactSave = "/todo/parties/contact",
  deleteContact = "/todo/parties/contact/:id",

  contactOrgSave = "/todo/parties/contact-org",
  deleteContactOrg = "/todo/parties/contact-org/:id",

  activityToPartyContactOrgSave = "/todo/parties/activity-to-party-contact-org",
  deleteActivityToPartyContactOrg = "/todo/parties/activity-to-party-contact-org/:id",
  getActivityToPartyContactOrg = "/todo/parties/activities/contact-org/:id",

  activityToPartyContactSave = "/todo/parties/activity-to-party-contact",
  deleteActivityToPartyContact = "/todo/parties/activity-to-party-contact/:id",
  getActivityToPartyContact = "/todo/parties/activities/contact/:id",

  activityParentCheck = "/todo/activity/parent/check",
  streamParentCheck = "/todo/stream/parent/check",
}

export enum Scan {
  hostAdd = "/scan/host/add",
  scanIP = "/scan/ip",
  recentScanResult = "/scan/ip/latest",
  allScanResult = "/scan/ip/allresults",

  resolveHostname = "/scan/http/add",
  scanHeaders = "/scan/headers",
  getRecentHeaders = "/scan/headers/latest",
  getAllHeaders = "/scan/headers/allresults",

  tlsResolveHostName = "/scan/tls/add",
  tlsScan = "/scan/tls",
  tlsScanGetRecentRecord = "/scan/tls/latest",
  tlsScanGetAllRecords = "/scan/tls/allresults",

  mozObsScanner = "/scan/http/moz",
  mozObsGetRecord = "/scan/http/moz/run",
  mozObsGetAllRecords = "/scan/http/moz/runs",

  whoisScan = "/scan/domain/whois",
  whoisGetRecord = "/scan/whois/run",
  whoisGetAllRecords = "/scan/whois/runs",

  curlHttpScan = "/scan/curl/headers/http",
  curlHttpGetRecord = "/scan/curl/headers/http/run",
  curlHttpGetAllRecords = "/scan/curl/headers/http/runs",

  curlScan = "/scan/curl/headers",
  curlGetRecord = "/scan/curl/headers/run",
  curlGetAllRecords = "/scan/curl/headers/runs",

  mxtSpfScan = "/scan/mail/dns/spf/run",
  mxtSpfGetRecord = "/scan/mail/dns/spf/run",
  mxtSpfGetAllRecords = "/scan/mail/dns/spf/runs",

  mxtDmarcScan = "/scan/mail/dns/dmarc/run",
  mxtDmarcGetRecord = "/scan/mail/dns/dmarc/run",
  mxtDmarcGetAllRecords = "/scan/mail/dns/dmarc/runs",

  scanReport = "/scan/report/run",
  scanReportSummary = "/scan/report/run/summary",
  diffScanReport = "/scan/report/run/diff",
  diffScanReportCSV = "/scan/report/run/diff/csv",

  scanReportDomain = "/scan/report/run/domain",
  scanReportDomainSummary = "/scan/report/run/domain/summary",
  scanReportDomainCSV = "/scan/report/run/domain/csv",

  dnsScan = "/scan/dns/caa/run",
  dnsGetRecord = "/scan/dns/caa/run",
  dnsGetAllRecords = "/scan/dns/caa/runs",
}

export enum Referral {
  refer = "/refer",
  callback = "/refer/callback",
}

export enum Invite {
  orgAccessRequest = "/org/access/request",
  orgAccessRequestProcess = "/org/access/request/process",
  getOrgAccessRequest = "/org/access/requests",
  orgAccessOffer = "/org/access/offer",
  orgAccessOfferProcess = "/org/access/offer/process",
  getOrgAccessOffers = "/org/access/offers",
  inviteInternal = "/user/invite",
  inviteInternalCallback = "/org/access/callback",
  getSystemActions = "/system/actions",
}

export enum Assessment {
  getChecklists = "/checklists",
  checkListFromMasterAll = "/checklist/from/master/all",
  checkListIdMetricsCompletion = "/checklist/:checklistId/metrics/completion",
  getDetailFromCheckListId = "/checklist/:checkListId/info/details",
  getInputComplianceTypes = "/checklist/inputs/compliance/type/values",
  getCategories = "/checklist/:checkListId/summary/by/category",
  getChecklistsByCategory = "checklist/:checklistId/items/by/category/:categoryId",
  checkListIdMetricsCountCompliance = "/checklist/:checklistId/metrics/count/compliance/lt",
  getChecklistContributors = "/checklist/:checklistId/info/contributors",
  postAnswerQuestion = "/checklist/items",
  postDuplicateQuestion = "/checklist/items/duplicate",
  getChecklistAll = "/checklist/:checklistId/items/all",
  getTemplate = "/checklist/templates",
  getTemplateDetail = "/checklist/template/:templateId/details",
  getCheckListDuplicate = "/checklist/:checklistId/duplicate",
  checklistStatus = "/checklist/:checklistId/status",
  checklistRename = "/checklist/:checklistId",
  postChecklistTemplate = "/checklist/:checklistId/to/template",
  putChecklistTemplate = "/checklist/:checklistId/to/template/:templateId",
  checklistAttachment = "/checklist/item/:checklistItemId/attachment",
  checklistAttachments = "/checklist/item/attachments",
  getAttachment = "/checklist/item/attachment/:attachmentId",
  getImportanceAssessment = "/checklist/inputs/importance",
  getImpactAssessment = "/checklist/inputs/impact",
  getEffortAssessment = "/checklist/inputs/effort",
  getCostAssessment = "/checklist/inputs/cost",
  getUserUploadFile = "/user/:userId",
  getChecklistGroupTemplateMetrics = "/checklist/:checklistId/groups/templates/metrics",
  deleteChecklist = "/checklist/:checklistId",
}

export enum Org {
  domain = "/org/domain",
  getDomain = "/org/domain/:id?",
  getDomains = "/org/:id/domains",
  getOrgs = "/orgs",
  switchOrg = "/org/switch",
  leaveOrg = "/org/:orgId/membership",
  switchToHomeOrg = "/org/switch/home",
  getOrg = "/org/:id",
  getOrgProfile = "/org/profile",
  postOrgProfile = "/org/profile",
  orgToProfileImageSave = "/org/profile/avatar",
  orgToProfileLogoSave = "/org/profile/logo",
  orgToProfileLogoDel = "/org/profile/logo/:imageId",
  getOrgsToProfileImages = "/orgs/profile/avatars",
  orgToProfileImageUpdate = "/org/profile/avatar",
  getOrgsSwitch = "/orgs/switch",
  getOrgVerify = "/org/verify",
  deleteOrgToProfileImage = "/org/profile/avatar",
  orgDomainVerifyInitiate = "/org/domain/verify/initiate",
  orgDomainVerifyCheck = "/org/domain/verify/check",
  orgDomainVerifyEmailCallback = "/org/domain/verify/email/callback",
  orgDomainVerifyCallback = "/org/domain/verify/callback",
  orgDomainVerify = "/org/domain/:domainId/verify/email",
  getMembersOfRole = "/org/role/:id/members",
  getOrgRoleById = "/org/role/:id",
  getOrgRoles = "/org/roles",
  getOrgRoleTypes = "/org/role/types",
  getOrgDomainsInvalid = "/org/domains/invalid",
  getOrgAccessTypes = "/org/access/types",
  createOrg = "/org",
  createRequestVerification = "/org/verify",
  deleteOrgRequest = "/org/verify",
  editRequestVerification = "/org/verify/:orgVerifyId",
  getMembersOfOrg = "/org/members/internal",
  getExternalMembersOfOrg = "/org/members/external",
  updateMemberRoles = "/org/member/:userId/roles",
  getAccessGrantedToOtherOrgs = "/org/access/granted/to/other",
  getAccessGrantedToCurrentOrg = "/org/access/granted/to/oid",
  getPermissionLevelDetailsOfRoleType = "/org/role/type/:roleId/perm/level",
  deleteAccessGrant = "/org/access/grants",
  getAccessGrants = "/org/access/grants",
  createMember = "/org/member",
  updateOrgMember = "/org/member/:userId",
  deleteOrgMember = "/org/member/:userId",
  postOrgMemberMfaEnable = "/org/member/:userId/mfa/reset",
  postOrgMemberUnlock = "/org/member/:userId/unlock",
  resetPasswordOrgExternalMember = "/org/member/:userId/password/reset",
  deleteOrgExternalMember = "/org/member/external/:userId",
  deactivateOrgMember = "/org/member/:userId/deactivate",
  reactivateOrgMember = "/org/member/:userId/reactivate",
  getAddableOrgMembers = "/org/:orgId/members/addable",
  putMemberRoles = "/org/member/:userId/roles",
  putMember = "/org/member/:userId",
  resetPasswordOrgMember = "org/member/:userId/password/reset",
  postOrgRole = "/org/role",
  putOrgProfile = "/org",
  getOrgPermLevels = "/org/role/perm/levels",
  deleteRole = "/org/role/:roleId",
  deleteMembersOfRole = "org/role/:roleId/members",
  getOrgsCurrent = "/org/switch/current",
  getParentOrg = "/org/:orgId",
  getOrgIdProfile = "/org/:orgId/profile",
  getRoleByUserId = "/org/member/:userId/roles",

  resetPasswordOrgMembers = "/org/members/password/reset",
  postOrgMembersMfaReset = "/org/members/mfa/reset",
  deleteOrgMembersMfaResetPasskey = "/user/mfa/passkeys",
  putOrgMembersDeactivate = "/org/members/deactivate",
  putOrgMembersActivate = "/org/members/activate",
  deleteOrgMembersDelete = "/org/members/internal",
  deleteOneOrgMemberExternalDelete = "/org/member/external/:memberId",
  deleteOrgMembersExternalDelete = "/org/members/external",
  deleteOrgDomains = "/org/domains",
  deleteOrgAccessGrants = "/org/access/grants",
  restoreUser = "/org/member/:userId/undelete",
  unVerifyDomain = "/org/domain/unverify",
  unVerifyDomainEmail = "/org/domains/unverify/email",

  getOrgSetup = "/org/setup",
  postOrgSetup = "/org/setup/org",
  postGoalSetup = "/org/setup/goals",
  postDomainSetup = "/org/setup/domains",
  postBrandSetup = "/org/setup/brands",
  postServicesSetup = "/org/setup/services",
  postMiscSetup = "/org/setup/misc",
  postTeamsSetup = "/org/setup/teams",
  postSiteSetup = "/org/setup/sites",
  postWebFacingSetup = "/org/setup/webservices",
  postProviderSetup = "/org/setup/providers",

  orgUserUploadAvatar = "/user/profile/avatar",
  postOrgVerifiCallback = "/org/verify/callback",
  delOrgUserUploadAvatar = "/user/profile/image/:imageId",
  postOrgMemberVerify = "/org/member/:userId/email/verify",
  getOrgIncidents = "/org/incidents",
  getOrgIncidentType = "org/incident/types",
  postOrgIncident = "/org/incident",
  putOrgIncidents = "/org/incident/:incidentId",
}

export enum Checklist {
  getChecklistForeCasts = "/checklist/forecasts",
  getTemplates = "/checklist/templates",
  getTemplate = "/checklist/template?templateId=",
  deleteChecklistTemplate = "/checklist/templates/delete",
  createChecklistToItem = "/checklist/from/template",
  getChecklists = "/checklists",
  getChecklist = "/checklist?checklistId=",
  refreshChecklistToItem = "/checklist/from/template",
  updateChecklistToItem = "/checklist/items",
  getChecklistToItemDetails = "/checklist/details?checklistId=",
  getChecklistToItemDetailsCSV = "/checklist/details/csv?checklistId=",
  toggleChecklistToItem = "/checklist/items/exclude/toggle",
  getChecklistToItemMetricCompletion = "/checklist/metrics/completion?checklistId=",
  getChecklistToItemMetric = "/checklist/metrics?checklistId=:checklistId",
  createChecklistItemGroup = "/checklist/group/apply",
  getChecklistItemGroupDetails = "/checklist/group?checklistId=",
  refreshChecklistItemGroup = "/checklist/group/apply",
  AddChecklistItemToExistChecklistItemGroup = "/checklist/group/items",
  createChecklistItemGroupFromChecklistItems = "/checklist/group",
  updateChecklistItemGroup = "/checklist/group",
  getChecklistItemGroup = "/checklist/groups?checklistId=",
  deleteChecklistGroupItems = "/checklist/group/items",
  getChecklistAttachment = "/checklist/item/attachment/:attachmentId",

  getChecklistItemGroupTemplates = "/checklist/groups/templates",
  getChecklistItemGroupTemplateById = "/checklist/groups/template?groupTemplateId=",
  getChecklistItemGroupsMetrics = "/checklist/groups/metrics",

  getChecklistCategories = "/checklist/categories?checklistId=",
  createChecklistForecast = "/checklist/forecast",
  createChecklistForecastMetrics = "/checklist/forecast/metrics",
  getChecklistForecasts = "/checklist/forecasts",
  deleteChecklistForecasts = "/checklist/forecasts",
  getChecklistReportData = "/checklist/:checklistId/report/data",
  getChecklistReportDataSummary = "/checklist/:checklistId/report/data/summary",
  getChecklistReportDataMetrics = "/checklist/:checklistId/report/data/metrics",
  getChecklistReportDataForecasts = "/checklist/:checklistId/report/data/forecasts",
  getChecklistReportDataHistory = "/checklist/:checklistId/report/data/history",
  getChecklistReportDataActions = "/checklist/:checklistId/report/data/actions",
  getChecklistReportDataCategories = "/checklist/:checklistId/report/data/categories",
  getChecklistReportDataInfographics = "/checklist/:checklistId/report/data/infographics",
  getChecklistReportDataIncidents = "/checklist/:checklistId/report/data/incidents",
  getChecklistReportDataPDF = "/checklist/report/data/pdf?checklistId=",
  createChecklistToStatus = "/checklist/status",
  getChecklistStatus = "/checklist/status?checklistId=",
  getChecklistStatusHistory = "/checklist/status/history?checklistId=",

  createChecklistShared = "/checklist/shared",
  getChecklistSharedById = "/checklist/shared?checklistSharedId=",
  getChecklistsShared = "/checklists/shared",
  updateChecklistShared = "/checklist/shared",
  createChecklistSharedStatus = "/checklist/shared/status",
  getChecklistSharedStatus = "/checklist/shared/status?checklistSharedId=",
  getChecklistSharedStatusHistory = "/checklist/shared/status/history?checklistSharedId=",
  createChecklistSharedToAuditStatus = "/checklist/shared/audit/status",
  getChecklistSharedAuditStatus = "/checklist/shared/audit/status?checklistSharedId=",
  getChecklistSharedAuditStatusHistory = "/checklist/shared/audit/status/history?checklistSharedId=",
  createChecklistRequested = "/checklist/requested",
  updateChecklistRequested = "/checklist/requested",
  getChecklistRequested = "/checklist/requested/:checklistRequestedId",
  createChecklistRequestedToStatus = "/checklist/requested/status",
  getChecklistsRequested = "/checklists/requested",
  getChecklistRequestedStatus = "/checklist/requested/status?checklistRequestedId=",
  getChecklistRequestedStatusHistory = "/checklist/requested/status/history?checklistRequestedId=",
  createChecklistSharedToOrgPublish = "/checklist/shared/grant/org/publish",
  getChecklistSharedToOrgPublish = "/checklist/shared/grant/org/publish?checklistSharedToOrgPublishId=",
  getChecklistSharedToOrgPublishByOrgId = "/checklist/shared/grant/org/publishs",
  updateGetChecklistSharedToOrgPublish = "/checklist/shared/grant/org/publish",
  createChecklistSharedToOrgRequest = "/checklist/shared/grant/org/request",
  createChecklistGrantToOrg = "/checklist/shared/grant/org",
  updateChecklistGrantToOrg = "/checklist/shared/grant/org",
  getChecklistGrantToOrg = "/checklist/shared/grant/org?checklistSharedToOrgGrantId=",
  getChecklistSharedToOrgGrantByOrgId = "/checklist/shared/grants/org?orgGrantorId=",
  addItemFromMaster = "/checklist/:checklistId/items/from/master",
  getChecklistGroup = "/checklist/:checklistId/group/:checklistGroupId",
  getChecklistGroupSuggestedActions = "/checklist/groups/template/:groupTemplateId?checklistId=:checklistId",

  getChecklistGroupMetrics = "/checklist/:checklistId/groups/metrics",
  getChecklistGroups = "/checklist/:checklistId/groups",
  createChecklistGroupMetrics = "/checklist/:checklistId/group/template/:groupTemplateId/apply",

  removeActionTable = "/checklist/:checklistId/groups/archive/toggle",
  getChecklistCSV = "/checklist/:checklistId/items/all/csv",
  getChecklistImpactLevel = "checklist/inputs/risks/impactlevel",
  getChecklistCost = "checklist/inputs/cost",
  putChecklistCategoryInfo = "/checklist/:checklistId/category/:categoryId/info",

  getChecklistGroupAction = "/checklist/:checklistId/group/:checklistGroupId/actions",
  getChecklistGroupTemplateAction = "/checklist/groups/template/:groupTemplateId/actions",
  putChecklistSuggestedAction = "/checklist/groups/template/:groupTemplateId",
  removeStep = "/checklist/:checklistId/group/:checklistGroupId/action/:actionId",
  addStep = "/checklist/:checklistId/group/:checklistGroupId/action",
  putChecklistRequestedEmailGrant = "/checklist/requested/:checklistRequestedId/status",
  getAssessmentItemsCSV = "/checklist/requested/:checklistRequestedId/items/csv",
}

export enum Scanning {
  getScansSummary = "/scans/summary/:scanType",
  getScanHistoryWebServices = "/scans/history/webServices",
  getScanHistoryDomains = "/scans/history/domains",
  getScanReportWebService = "/scan/report/run/csv?runId=",
  getScanReportDiffWebService = "/scan/report/run/diff/csv?runId=",
  getScanReportDomain = "/scan/report/run/domain/csv?runId=",
  getScanReportWebServiceCSV = "/scan/report/run/csv?runId=",
  getScanReportDomainCSV = "/scan/report/run/domain/csv?runId=",
  getScanReportRunWebService = "/scan/report/run",
  postScanReportRunWebService = "/scan/report/run",
  getScanReportRunDomain = "/scan/report/run/domain",
  postScanReportRunDomain = "/scan/report/run/domain",
  getScanReportScheduleWebServices = "/scan/report/schedule/webservices",
  getScanReportScheduleDomains = "/scan/report/schedule/domains",
  getRefreshIssuesWebServiceScanning = "/scans/history/webservices?webserviceIds[]=:webserviceId",
  getRefreshIssuesDomainScanning = "/scans/history/domains?domainIds[]=:domainId",
  postScanReportScheduleDomains = "/scan/report/schedule/domains",
  postScanReportScheduleWebServices = "/scan/report/schedule/webservices",
  postIgnoreScanReportItem = "/scans/report/item/ignore",
  getIgnoreScanReportItem = "/scans/report/item/ignore",
  deleteIgnoreScanReportItem = "/scans/report/item/ignore",
}

export enum Subscription {
  getSessionPortal = "/subs/portal/session",
  getSessionId = "/subs/customer/session",
  getOrgSubsPlan = "/org/subs/plan",
}

export enum Vendor {
  getChecklistRequestedEmailGrant = "/checklist/requested/:checklistRequestedId/email/:emailGrantId",
  getRequestedDetailItem = "/checklist/requested/:checklistRequestedId/items",
  putRequestedDetailItem = "/checklist/requested/:checklistRequestedId/items",
  getRequestedAssessment = "/checklists/requested",
  postRequestedAssessment = "/checklist/requested",
  putRequestedAssessment = "/checklist/requested/:checklistRequestedId",
  postChecklistRequestedGetSecret = "/checklist/requested/:checklistRequestedId/email",
  getRequestedTemplate = "/checklist/requested/templates",
  postChecklistRequestedTemplate = "/checklist/requested/template",
  putChecklistRequestedTemplate = "/checklist/requested/template/:templateId",
  postExternalCallback = "/checklist/requested/email/callback",
  getRequestedTemplateDetail = "/checklist/requested/template/:templateId",
  postRequestTemplateItem = "/checklist/requested/template/:templateId/item",
  putRequestTemplateItem = "/checklist/requested/template/:templateId/item",
  requestedTemplateDetail = "/checklist/requested/template/:templateId",
  putChecklistRequestedTemplateItem = "/checklist/requested/template/:templateId/item",
  vendorRequestedExternalInput = "/checklist/requested/email",
  putChecklistRequestedItems = "/checklist/requested/email/:checklistRequestedId/items",
  postRequestAssessmentAttachment = "/checklist/requested/email/:checklistRequestedId/item/:checklistItemId/attachment",
  deleteRequestAssessmentAttachment = "/checklist/requested/email/:checklistRequestedId/item/:checklistItemId/attachments",
  deleteVendorRequestAssessmentAttachment = "/checklist/requested/:checklistRequestedId/item/:checklistItemId/attachments",
  getChecklistRequestedComplianceTypeValues = "/checklist/requested/email/inputs/compliance/type/values",
  putChecklistRequestedExternalItem = "/checklist/requested/email/:checklistRequestedId/items",
  deleteChecklistRequestedAttachment = "/checklist/requested/email/:checklistRequestedId/item/:checklistItemId/attachments",
  getRequestAssessmentAttachment = "/checklist/requested/email/item/attachment/:attachmentId",
  getRequestVendorAssessmentAttachment = "/checklist/requested/item/attachment/:attachmentId",
  postRequestAssessmentEmailSubmit = "/checklist/requested/email/:checklistRequestedId/submit",
  putRequestAssessmentEmail = "/checklist/requested/email/:checklistRequestedId",
  putChecklistRequestedEmailGrant = "/checklist/requested/:checklistRequestedId/email/:emailGrantId",
  postChecklistRequestedStatus = "/checklist/requested/:checklistRequestedId/status",
  postChecklistResendVendor = "/checklist/requested/:checklistRequestedId/email/:emailGrantId/resend",
  getRequestVandorAssessmentAttachment = "getRequestVandorAssessmentAttachment",
  getChecklistRequestedEmailGrants = "/checklist/requested/:checklistRequestedId/email/grants",
  createChecklistRequestedEmailGrant = "/checklist/requested/:checklistRequestedId/email",
}
